var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_526_2146)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.7943 12.6565C13.7943 16.4917 10.7062 19.6008 6.89723 19.6008C3.08821 19.6008 0 16.491 0 12.6565C0 8.82192 3.08798 5.71191 6.89723 5.71191C10.7065 5.71191 13.7943 8.82122 13.7943 12.6565ZM21.3605 12.6565C21.3605 16.2665 19.8165 19.1942 17.9119 19.1942C16.0072 19.1942 14.4632 16.2665 14.4632 12.6565C14.4632 9.04641 16.0069 6.11871 17.9116 6.11871C19.8162 6.11871 21.3605 9.04547 21.3605 12.6565ZM24.4553 12.6565C24.4553 15.8902 23.9123 18.5133 23.2423 18.5133C22.5724 18.5133 22.0297 15.8909 22.0297 12.6565C22.0297 9.42203 22.5726 6.79966 23.2423 6.79966C23.912 6.79966 24.4553 9.4218 24.4553 12.6565Z",
    fill: "#C7C7C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_526_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 13.8889,
    fill: "white",
    transform: "translate(0 5.71191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMedium);
export default __webpack_public_path__ + "static/media/footerMedium.ef6c7afddcdb54db83f22dce6486cca7.svg";
export { ForwardRef as ReactComponent };